import { render, staticRenderFns } from "./WidgetHead.vue?vue&type=template&id=21c48b13&scoped=true&"
import script from "./WidgetHead.vue?vue&type=script&lang=js&"
export * from "./WidgetHead.vue?vue&type=script&lang=js&"
import style0 from "./WidgetHead.vue?vue&type=style&index=0&id=21c48b13&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c48b13",
  null
  
)

export default component.exports